import styled, { css } from 'styled-components/macro';
import { colorCoreWhite1000, colorCoreGray300 } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { elevationBottomLvl2 } from '@yme/tokens/elevations';
import { getTextStyles } from '@yme/utils/styles';
export const OverflowMenuStyled = styled.div `
  position: absolute;
  flex-direction: column;
  top: 100%;

  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 0;' : 'right: 0;')};
`;
export const UlMenu = styled.ul `
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  list-style: none;
  align-items: flex-start;
  padding: 6px;
  width: 204px;
  height: 92px;
  margin: 0;

  background-color: ${colorCoreWhite1000};
  border: 1px solid ${colorCoreGray300};
  box-shadow: ${elevationBottomLvl2};
  border-radius: ${CORNER_RADIUS.m};
`;
export const ItemMenu = styled.li `
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  width: 192px;
  height: 40px;

  border-radius: ${CORNER_RADIUS.xs};

  ${({ isRightToLeft }) => isRightToLeft
    ? css `
          direction: rtl;
          padding: 8px 12px 8px 8px;
        `
    : css `
          direction: ltr;
          padding: 8px 8px 8px 12px;
        `}

  &:hover {
    background-color: ${colorCoreGray300};
    border-radius: ${CORNER_RADIUS.xs};
  }
`;
export const ItemTitle = styled.span `
  ${getTextStyles('Ubuntu', 400, 14, 20)}

  letter-spacing: 0px;
  text-align: left;
`;
